/* eslint-disable no-restricted-globals */
import {useLocation, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import axios from "axios";
import {restUrl} from "../../../../apiUrl";
import '../../../../index.css'
import {MetaDataTable} from "../component/MetaDataTable";

export const ManualGrading = () => {
    const { state } = useLocation()

    const [metaData, setMetaData] = useState({})
    const [list, setList] = useState([])

    useEffect(() => {
        init()
    }, []);

    const init = async () => {
        const {data} = await axios.get(`${restUrl}/activity_test_problem_view_grade?test_id=eq.${state.testId}&app_id=eq.${state.appId}`)
        setList(data)
        const res = await axios.get(`${restUrl}/list_test_grade?test_id=eq.${state.testId}&app_id=eq.${state.appId}`)
        setMetaData(res.data)
    }

    const changeGrade = (index, e)=>{
        const d = [...list]
        d[index].add = e.target.value
        setList(d)
    }

    const navigate = useNavigate()
    const submitGrade = async () => {
        const c = window.confirm("저장하시겠습니까?")
        if (!c) return
        await axios.patch(`${restUrl}/activity_test_application?id=eq.${state.appId}`, {manual_graded: true})
        for (const item of list) {
            await axios.patch(`${restUrl}/activity_test_problem_response_grade?id=eq.${item.grade_id}`,{grade: item.grade})
        }
        alert('저장되었습니다.')
        navigate(-1)
    }

    return (<>
        <MetaDataTable data={metaData}/>
        <table>
            <thead><tr>
                <th>번호</th>
                <th>문제</th>
                <th>보기</th>
                <th>정답</th>
                <th>제출한 답</th>
                <th>배점</th>
                <th>AI점수</th>
                <th>수기점수</th>
                <th>난이도</th>
            </tr></thead>
            <tbody>
            {list.length > 0 && list.map((item, index) => <tr key={index}>
                <td>{index+1}</td>
                <td>{item.problem}</td>
                <td>{item.selection}</td>
                <td>{item.answer}</td>
                <td>{item.response}</td>
                <td>{item.score}</td>
                <td>{item.grade}</td>
                <td><input className='inputBorder inputTextAreaMargin' value={item.add}
                    onChange={event => changeGrade(index, event)}/></td>
                <td>{item.difficulty}</td>
            </tr>)}
            </tbody>
        </table>
        <button onClick={submitGrade}>저장</button>
    </>)
}